<template>
  <div class="tw:flex tw:justify-between tw:gap-4 tw:border-t-1 tw:border-gray-300">
    <textarea
      id="chatInputText"
      v-model="message"
      @input="adjustHeight"
      @keydown.enter.exact.prevent="handleSend"
      ref="inputRef"
      :placeholder="$t('chatbot_text_box')"
      rows="1"
      class="tw:w-full tw:resize-none tw:overflow-y-hidden tw:focus:outline-none"
    />
    <button @click="handleSend" class="tw:cursor-pointer">
      <ChatArrowSend class="tw:size-6" />
    </button>
  </div>
</template>

<script setup>
import { ref, nextTick } from 'vue'

import ChatArrowSend from '@/components/icons/ChatArrowSend.svg?component'
import useChat, { authors } from '@/components/chatbot/useChat'

const message = ref('')
const inputRef = ref(null)

const MAX_HEIGHT = 120

const adjustHeight = async () => {
  await nextTick()
  const textarea = inputRef.value

  textarea.style.height = 'auto'
  const scrollHeight = textarea.scrollHeight

  if (scrollHeight > MAX_HEIGHT) {
    textarea.style.height = MAX_HEIGHT + 'px'
    textarea.style.overflowY = 'auto'
  } else {
    textarea.style.height = scrollHeight + 'px'
    textarea.style.overflowY = 'hidden'
  }
}
const resetTextareaHeight = () => {
  if (inputRef.value) {
    inputRef.value.style.height = 'auto'
    inputRef.value.style.overflowY = 'hidden'
  }
}

const { addMessage, isAwaitingReply } = useChat()

const handleSend = () => {
  if (!message.value?.trim() || isAwaitingReply.value) return
  addMessage(message.value, authors.USER)
  message.value = ''
  resetTextareaHeight()
}
</script>
